/**
 * Formats a number using compact notation (e.g., 3163 → 3.2K, 1000 → 1K, 500 → 500).
 * Uses Intl.NumberFormat for consistent, locale-aware formatting.
 */
export const formatCompactNumber = (
    value: number | null | undefined
): string => {
    if (value === null || value === undefined) return '0'
    const num = Number(value)
    if (isNaN(num)) return '0'

    const formatter = new Intl.NumberFormat('en-US', {
        notation: 'compact',
    })
    return formatter.format(num)
}
